// 运营决策智能体产品分类与产品矩阵数据
import imgDisplay1 from "@/../static/img/operationDecision/企业展厅智能体.jpg";
import imgDisplay2 from "@/../static/img/operationDecision/文博智能体.jpg";
import imgRnd from "@/../static/img/operationDecision/产线质量问数分析.jpg";
import imgFinance1 from "@/../static/img/operationDecision/财务问数分析智能体.jpg";
import imgFinance2 from "@/../static/img/operationDecision/审计智能体.jpg";
import imgFinance3 from "@/../static/img/operationDecision/稽核智能体.jpg";
import imgOperation from "@/../static/img/operationDecision/项目智能评审.jpg";

export const OPERATION_DECISION_CATEGORIES = [
  {
    key: "display",
    title: "互动展示",
    bgType: 2,
    products: [
      {
        title: "企业展厅智能体",
        info:
          "传统企业/园区展厅运营的核心痛点在于：内容分散难沉淀、更新依赖人工、展示表达偏静态，导致展厅「常展常旧」、讲解效率低、互动体验弱。运营决策智能体通过智能策展、动态内容更新、多场景自动讲解与多模态交互，推动展厅从「静态展示」升级为「常展常新、可运营、可交互」的智能展示空间。",
        image: imgDisplay1,
        alt: "企业展厅智能体"
      },
      {
        title: "文博智能体",
        info:
          "传统文博展示的核心痛点在于：专业知识难转化、内容生产慢更新难、讲解形式单一，导致馆藏价值难以被每一个观众真正理解和持续传播。文博智能体通过知识构建、内容生成与场景适配，打通「策展—展陈—体验—传播」全流程，让文博内容可生产、可更新、可交互、可分发。",
        image: imgDisplay2,
        alt: "文博智能体"
      }
    ]
  },
  {
    key: "rnd",
    title: "研发生产",
    bgType: 1,
    products: [
      {
        title: "产线质量问数分析",
        info:
          "数据分析是业务诊断与决策的关键支撑，但传统方式往往门槛高、响应慢。我们通过对接多源数据，并梳理生产相关专家知识、业务指标逻辑，实施搭建私有化部署的产线质量数据分析智能体。实现生产管理人员通过自然语言问数、自动生成统计图表，让智能体不但会统计也懂业务，不但能问「是什么」，也能分析「为什么」、「怎么办」。",
        image: imgRnd,
        alt: "产线质量问数分析"
      }
    ]
  },
  {
    key: "finance",
    title: "财务",
    bgType: 2,
    products: [
      {
        title: "财务问数分析智能体",
        info:
          "多元化集团/大型企业并非单一利润导向，而是以核心资源的全局统筹与价值闭环为核心诉求；其组织形态单元多、领域跨度广。我们运用快速构建本体知识的方法论，搭建财务数据语义网络与问数智能体。通过标准化定义业务实体、关系与规则，归拢分散信息、打通数据壁垒，支持灵活组合与深度下钻，洞悉趋势、驱动决策。",
        image: imgFinance1,
        alt: "财务问数分析智能体"
      },
      {
        title: "审计智能体",
        info:
          "面对大体量客户年均数千个项目的评审需求，传统专家审核周期长、耗时耗力，标准不统一，评审标准更新后更是执行滞后。我们借助非结构化文档解析和知识快速抽取和理解的能力，建立包含评审标准、动态规则、历史案例、以及不同类型项目评审流程的知识体系，在LLM与领域知识相融合的范式下，搭建项目评审场景智能体。帮助企业提升项目管理的效率和质量。",
        image: imgFinance2,
        alt: "审计智能体"
      },
      {
        title: "稽核智能体",
        info:
          "构建面向财务固定资产管理的智能体，整合来自设备管理系统、财务系统、ERP资产模块等系统的数据，并梳理企业内部固定资产管理制度、相关元数据，形成固定资产本体知识。构建带有记忆机制和推理能力的智能体，实现固定资产数据的自动稽核、对话式查询、以及稽核规则的衍生更新，推动固定资产管理从粗放式向精益化转变。",
        image: imgFinance3,
        alt: "稽核智能体"
      }
    ]
  },
  {
    key: "operation",
    title: "运营决策",
    bgType: 1,
    products: [
      {
        title: "项目智能评审",
        info:
          "面对大体量客户年均数千个项目的评审需求，传统专家审核周期长、耗时耗力，标准不统一，评审标准更新后更是执行滞后。我们借助非结构化文档解析和知识快速抽取和理解的能力，建立包含评审标准、动态规则、历史案例、以及不同类型项目评审流程的知识体系，在LLM与领域知识相融合的范式下，搭建项目评审场景智能体。帮助企业提升项目管理的效率和质量。",
        image: imgOperation,
        alt: "项目智能评审"
      }
    ]
  }
];

export function getCategoryByKey(key) {
  return OPERATION_DECISION_CATEGORIES.find(item => item.key === key);
}



// WEBPACK FOOTER //
// ./src/view/product/operationDecision/categoryData.js